import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import style from './UnderlinedCTA.scss';

const cx = classNames.bind(style);

const UnderlinedCTA = ({
  as = '',
  children,
  variant = '',
  error = false,
  ...rest
}) => {
  const Component = as || Link;

  return (
    <Component
      className={cx('underlined-cta', variant, {
        'underlined-cta__error': error,
      })}
      {...rest}
    >
      {children}
    </Component>
  );
};

UnderlinedCTA.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  as: PropTypes.string,
  error: PropTypes.bool,
};

export default UnderlinedCTA;
